import { pointsEarnedInRace } from "@/utils/league-points";

function participatedRaces (squad) {
  return squad.league.races.filter(r => !r.isBracketRace && r.decided && r.squadIds.includes(squad.id));
}

function ordinalSum (squad) {
  return squad.members.reduce((sum, member) => sum + member.startOfLeagueOrdinal, 0);
}

function goalDiffForRace (squad, race) {
  const opponentId = race.squadIds.find(id => id !== squad.id);
  if (!opponentId) return 0;
  return (race.goalsBySquadId[squad.id] || 0) - (race.goalsBySquadId[opponentId] || 0);
}

function goalsAgainstForRace (squad, race) {
  const opponentId = race.squadIds.find(id => id !== squad.id);
  return opponentId ? race.goalsBySquadId[opponentId] || 0 : 0;
}

export function squadStats (squad) {
  const races = participatedRaces(squad);
  const points = races.reduce((sum, race) => sum + pointsEarnedInRace(race, squad.id), 0);
  const wins = races.filter(r => r.winningSquadId === squad.id).length;
  const losses = races.length - wins;
  const nearLosses = races.filter(r => r.winningSquadId !== squad.id && pointsEarnedInRace(r, squad.id) === 1).length;
  return {
    played: races.length,
    wins,
    losses,
    nearLosses,
    points,
    goalsFor: races.reduce((sum, race) => sum + (race.goalsBySquadId[squad.id] || 0), 0),
    goalsAgainst: races.reduce((sum, race) => sum + goalsAgainstForRace(squad, race), 0),
    goalDiff: races.reduce((diff, race) => diff + goalDiffForRace(squad, race), 0),
    ordinalSum: ordinalSum(squad)
  };
}

export function rankSquads (squads) {
  const played = [];
  const unplayed = [];
  for (const squad of squads) {
    const stats = squadStats(squad);
    const row = { squad, ...stats };
    if (stats.played > 0) {
      played.push(row);
    } else {
      unplayed.push(row);
    }
  }
  played.sort((a, b) => {
    const pts = b.points - a.points;
    if (pts !== 0) return pts;
    const w = b.wins - a.wins;
    if (w !== 0) return w;
    const diff = b.goalDiff - a.goalDiff;
    if (diff !== 0) return diff;
    return a.ordinalSum - b.ordinalSum;
  });
  let place = 1;
  const mapped = played.map((row, i) => {
    if (i > 0 && (row.points !== played[i - 1].points || row.wins !== played[i - 1].wins || row.goalDiff !== played[i - 1].goalDiff || row.ordinalSum !== played[i - 1].ordinalSum)) {
      place = i + 1;
    }
    return { ...row, place };
  });
  for (const row of unplayed) {
    mapped.push({ ...row, place: null });
  }
  return mapped;
}
